import historyDefault from '../../history';
import { ORDERS_BATCHES_PATH, SHIPMENTS_BATCHES_PATH } from '../../routes/constants';

export const getIsBatchDetailsPage = (history = historyDefault) => {
  const pathName = history.location.pathname;
  const isOnOrdersPage = pathName.includes(ORDERS_BATCHES_PATH) || window.location.href.includes(ORDERS_BATCHES_PATH);
  const isOnOpenBatchDetails = pathName.includes(SHIPMENTS_BATCHES_PATH) || window.location.href.includes(SHIPMENTS_BATCHES_PATH);

  return isOnOrdersPage || isOnOpenBatchDetails;
};
